import { useEffect } from 'react';
import {
  useApiContext,
  useGetActiveUserTournaments,
  useGetLocalTournaments
} from 'react-easyrocket';
import { getNextLocalTournament } from './utils/getNextLocalTournament ';
import { useNotifiacationLocalTournamentStore } from 'src/store';

export const useCheckForNewLocalTournament = () => {
  const { isAuthenticated } = useApiContext();
  const { tournaments: localTournaments, isFetched: isLocalTournamentsFetched } =
    useGetLocalTournaments();
  const { data: activeLocalUserTournaments, isFetched: isActiveUserTournamentsFetched } =
    useGetActiveUserTournaments();
  const { setNewTournament } = useNotifiacationLocalTournamentStore();

  useEffect(() => {
    if (!isLocalTournamentsFetched) return;
    if (isAuthenticated && !isActiveUserTournamentsFetched) return;

    const tournament = getNextLocalTournament(localTournaments?.active, activeLocalUserTournaments);

    if (tournament) {
      setNewTournament(tournament);
    } else {
      setNewTournament(null);
    }
  }, [isLocalTournamentsFetched, isActiveUserTournamentsFetched, isAuthenticated]);
};
